document.addEventListener("DOMContentLoaded", () => {
    const headerSwiper = document.querySelectorAll('#component-header-swiper .swiper')
    headerSwiper.forEach((el) => {
        const swiper = new Swiper(el, {
            grabCursor: true,
            spaceBetween: 15,
            direction: "vertical",
            loop: false,
            slidesPerColumn: 2,
            slidesPerView: 2,
            height: 350,
            navigation: {
                enabled: false
            },
            grid: {
                rows: 2,
                fill: 'row',
            },
            breakpoints: {
                768: {
                    navigation: {
                        enabled: true,
                        nextEl: '.kenner-arrow.--next',
                        prevEl: '.kenner-arrow.--prev',
                        disabledClass: 'disabled',
                    },
                    direction: "horizontal",
                    slidesPerColumn: 1,
                    slidesPerView: "auto",
                    grid: {
                        rows: 1,
                        fill: 'row',
                    }
                }
            },
            on: {
                afterInit: function () {
                    const prev = this.navigation.prevEl || null
                    if (prev && this.activeIndex === 0) {
                        prev.forEach((el) => el.classList.add('disabled'))
                    }
                }
            }
        })
    })
})
function filterSession(event, filter) {
    event.preventDefault(); // Prevent the default action (redirect)
    sessionStorage.setItem('gender-preference', filter)
    window.location.href = event.currentTarget.href;
}